import type { EventRunnerType, EventType } from "app/types/eventType";
import isEmpty from "lodash/isEmpty";
import ExchangeMarketRunnerPriceWrapper from "../ExchangeMarketRunnerPriceWrapper/ExchangeMarketRunnerPriceWrapper";
import EmptyExchangeMarketRow from "./components/ExchangeBlankRow/EmptyExchangeMarketRow";
import "./ExchangeMarketRunnerPrice.scss";

function ExchangeMarketRunnerPrice(props: {
  runner: EventRunnerType;
  event: EventType;
}) {
  const { runner, event } = props;
  // if no prices are available, return a blank row
  if (isEmpty(runner.aggregatedPrices)) {
    return <EmptyExchangeMarketRow />;
  }

  return (
    <span className={"exchange__runner-prices"}>
      {runner.aggregatedPrices && (
        <ExchangeMarketRunnerPriceWrapper
          key={runner.id}
          prices={runner.aggregatedPrices}
          event={event}
          runner={runner}
        />
      )}
    </span>
  );
}

export default ExchangeMarketRunnerPrice;
